import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-companylist-skeleton-loader',
    templateUrl: './companylist-skeleton-loader.component.html',
    styleUrls: ['./companylist-skeleton-loader.component.scss'],
    standalone: false
})
export class CompanylistSkeletonLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
